export function withHost(path: string) {
  const { resourcesUrl } = useRuntimeConfig().public
  return resourcesUrl + path
}

export function isExternalUrl(url: string | undefined | null): url is string {
  if (!url) return false

  if (url.startsWith('/')) {
    // probably a relative URL
    return false
  }

  if (!url.includes('://') && !url.startsWith('www.')) {
    // probably a relative URL
    return false
  }

  return true
}

export function normalizeUrl(url: string | undefined | null) {
  if (!url) {
    return undefined
  }

  if (url.startsWith('www.')) {
    return 'https://' + url
  }

  return url
}
